document.addEventListener('click', event => {
    const element = document.getElementById('currency-selector-mobile')
    element.setAttribute('aria-expanded', 'true');
    if (!element.contains(event.target)) {
      element.open = false;
      element.setAttribute('aria-expanded', 'false');
    }
  });
  if (!customElements.get("localization-form")) {
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.input = this.querySelector('input[name="language_code"], input[name="country_code"]'),
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }
  }

  customElements.define('localization-form', LocalizationForm);
}
